import { classnames, fCredit, toPercent } from '@aibees/shared/utils';

import { ProgressBar } from '../progress-bar';
import type { CreditProgressProps as Props } from './types';
import { memo } from 'react';

export const CreditProgress = memo(
  ({ className, charged, type, remaining, showWarning }: Props) => {
    const subPercent = toPercent(remaining, charged);
    const isCredit = type === 'Credit';
    // Rollover only shows "remaining"; "used" is meaningful for plan credits.
    const used = isCredit ? Math.max(charged - remaining, 0) : undefined;
    const isLow = !!showWarning && subPercent < 5;

    // Bar/track colors come from the MuiLinearProgress theme override.
    const color = isLow ? 'warning' : isCredit ? 'primary' : 'success';

    return (
      <ProgressBar
        className={classnames('CreditProgress', className)}
        icon={isCredit ? 'coin' : 'sync-outline'}
        iconColor="primary.500"
        title={isCredit ? 'Plan Credits' : 'Rollover Credits'}
        color={color}
        total={charged}
        remaining={remaining}
        used={used}
        format={fCredit}
      />
    );
  }
);

CreditProgress.displayName = 'CreditProgress';
